package org.zest.insan_360_website.pages.user.report_layout

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronRight
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.Select
import org.jetbrains.compose.web.dom.Text
import org.zest.insan_360_website.components.layouts.*
import org.zest.insan_360_website.components.widgets.*
import org.zest.insan_360_website.data.localized
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.data.page_states.UserPreferences
import org.zest.insan_360_website.data.page_states.dashboard.ReportDashPageState
import org.zest.insan_360_website.data.page_states.dashboard.ReportDashPageState.TestSubmissionFilter
import org.zest.insan_360_website.model.SubmissionHistory
import org.zest.insan_360_website.model.TestSubmissionStatus
import org.zest.insan_360_website.model.UserRole
import org.zest.insan_360_website.utils.formatToReadableDateJS
import kotlin.js.Date

@Composable
fun StudentLayout() {
    PageContentBaseCol {
        TestSubmissionHistoryList()
    }
}

@OptIn(DelicateApi::class)
@Composable
private fun TestSubmissionHistoryList() {
    val breakpoint = rememberBreakpoint()
    val modal = LocalModal.current

    TableFlushedListContainer(
        1,
        header = {
            Column(Modifier.fillMaxWidth().gap(0.75.cssRem)) {
                if (breakpoint >= Breakpoint.MD) {
                    Row(
                        Modifier.fillMaxWidth().gap(0.5.cssRem),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        SpanText(
                            userDashWordLibrary.report.localized,
                            Modifier.fontWeight(FontWeight.Bold).fontSize(1.5.cssRem).whiteSpace(WhiteSpace.NoWrap)
                        )
                        Row(
                            Modifier.justifyContent(com.varabyte.kobweb.compose.css.JustifyContent.FlexEnd).gap(0.5.cssRem),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            StatusFilterInput()
                        }
                    }
                } else {
                    Column(
                        Modifier.fillMaxWidth().gap(0.5.cssRem)
                    ) {
                        SpanText(
                            userDashWordLibrary.report.localized,
                            Modifier.fontWeight(FontWeight.Bold).fontSize(1.5.cssRem).whiteSpace(WhiteSpace.NoWrap)
                        )
                        Row(
                            Modifier.fillMaxWidth().justifyContent(com.varabyte.kobweb.compose.css.JustifyContent.FlexStart).gap(0.5.cssRem),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            StatusFilterInput()
                        }
                    }
                }
            }
        },
        listHeaders = {
            ListHeader(
                userDashWordLibrary.test_id.localized,
                modifier = Modifier
                    .position(Position.Sticky)
                    .left(0.5.cssRem)
                    .zIndex(10)
                    .backgroundColor(userPageBGColor)
                    .styleModifier { property("box-shadow", "-0.5rem 0 0 0 $userPageBGColor") }
            )
            ListHeader(userDashWordLibrary.credit_id.localized)
            ListHeader(userDashWordLibrary.organization_name.localized)
            ListHeader("Status")
            ListHeader(userDashWordLibrary.submission_date.localized)
            ListHeader("", true)
        },
        listHeadersModifier = Modifier
            .gap(0.25.cssRem)
            .grid {
                columns {
                    size(2.fr)
                    size(2.fr)
                    size(2.fr)
                    size(1.fr)
                    size(1.5.fr)
                    size(24.px)
                }
            }
    ) {
        val filteredList = ReportDashPageState.getFilteredSubmissionsHistory()

        if (ReportDashPageState.isLoadingHistory) {
            Box(Modifier.fillMaxWidth().minHeight(150.px).padding(1.cssRem), contentAlignment = Alignment.Center) {
                DotLoading()
            }
        } else if (filteredList.isEmpty()) {
            Box(Modifier.fillMaxWidth().minHeight(150.px).padding(1.cssRem), contentAlignment = Alignment.Center) {
                SpanText(
                    userDashWordLibrary.no_submissions.localized,
                    Modifier.color(userPageSecondaryTextColor).fontWeight(FontWeight.Medium)
                )
            }
        } else {
            var index = 0
            filteredList.forEach { history ->
                FlushedListRowWrapper(
                    index = index,
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .onClick {
                            modal.show { StudentReportDetailModal(history) }
                        }
                ) {
                    Row(
                        Modifier
                            .fillMaxWidth()
                            .minWidth(800.px)
                            .gap(0.25.cssRem)
                            .grid {
                                columns {
                                    size(2.fr)
                                    size(2.fr)
                                    size(2.fr)
                                    size(1.fr)
                                    size(1.5.fr)
                                    size(24.px)
                                }
                            },
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        val bgCol = if (index % 2 == 0) userPageColor else userPageBGColor
                        Box(
                            Modifier
                                .fillMaxWidth()
                                .position(Position.Sticky)
                                .left(0.5.cssRem)
                                .zIndex(2)
                                .backgroundColor(bgCol)
                                .styleModifier { property("box-shadow", "-0.5rem 0 0 0 $bgCol") }
                        ) {
                            CopyableIdText(history.testId)
                        }
                        Box(Modifier.fillMaxWidth()) {
                            CopyableIdText(history.creditId)
                        }
                        ListEntry(history.orgName ?: "-")
                        Box(Modifier.fillMaxWidth()) {
                            TestSubmissionStatusBadge(history.status)
                        }
                        ListEntry(formatToReadableDateJS(history.submittedAt))
                        Box(Modifier.fillMaxWidth().aspectRatio(1), contentAlignment = Alignment.Center) {
                            FaChevronRight(
                                Modifier
                                    .color(userPageSecondaryTextColor)
                                    .fontSize(0.8.cssRem)
                            )
                        }
                    }
                }
                index++
            }
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
private fun StatusFilterInput() {
    Select(
        Modifier
            .fontFamily("FunnelDisplay")
            .fontWeight(FontWeight.SemiBold)
            .padding(0.25.cssRem)
            .borderRadius(0.25.cssRem)
            .border {
                width(1.px)
                style(LineStyle.Solid)
                color(userPageBorderStrongColor)
            }
            .backgroundColor(userPageBGColor)
            .color(userPagePrimaryTextColor)
            .outline(0.px)
            .cursor(Cursor.Pointer)
            .toAttrs {
                onInput { e ->
                    e.value?.let {
                        ReportDashPageState.statusFilter = TestSubmissionFilter.valueOf(it)
                    }
                }
            }
    ) {
        TestSubmissionFilter.entries.forEach { option ->
            Option(
                value = option.name,
                attrs = {
                    if (option == ReportDashPageState.statusFilter) selected()
                }
            ) {
                val statusLabel =
                    userDashWordLibrary.testSubmissionFilterOptions[option.name]?.get(UserPreferences.language)
                        ?: option.name
                Text(statusLabel)
            }
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
private fun StudentReportDetailModal(history: SubmissionHistory) {
    val modal = LocalModal.current
    val toast = LocalToast.current
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val isMobile = breakpoint < Breakpoint.SM

    Column(
        Modifier
            .padding(if (isMobile) 0.5.cssRem else 1.5.cssRem)
            .gap(1.5.cssRem),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Column(Modifier.fillMaxWidth().gap(0.75.cssRem)) {
            Box(Modifier.fillMaxWidth(), contentAlignment = Alignment.CenterStart) {
                TestSubmissionStatusBadge(history.status)
            }
            SpanText(
                userDashWordLibrary.report.localized,
                Modifier
                    .align(Alignment.CenterHorizontally)
                    .fontWeight(FontWeight.Bold)
                    .fontSize(1.5.cssRem)
                    .color(userPagePrimaryTextColor)
                    .textAlign(TextAlign.Center)
            )
        }
        
        Column(Modifier.fillMaxWidth().gap(1.cssRem)) {
            StudentDataRow(
                value = history.testId,
                label = userDashWordLibrary.test_id.localized
            )
            StudentDataRow(
                value = history.creditId,
                label = userDashWordLibrary.credit_id.localized
            )
            StudentDataRow(
                value = history.orgName ?: "-",
                label = userDashWordLibrary.answered_under.localized
            )
            StudentDataRow(
                value = formatToReadableDateJS(history.submittedAt),
                label = userDashWordLibrary.submission_date.localized
            )
        }

        if (history.status == TestSubmissionStatus.VERIFIED) {
            val nowMillis = Date.now()
            val expiresAtMillis = history.reportExpiresAt?.toEpochMilliseconds()?.toDouble() ?: 0.0
            
            if (expiresAtMillis > nowMillis) {
                // Download Report
                Box(
                    contentButtonStyle.toModifier()
                        .fillMaxWidth()
                        .minHeight(3.cssRem)
                        .onClick {
                            if (!ReportDashPageState.isDownloading) {
                                ReportDashPageState.downloadVerifiedReport(history.testId, toast, scope)
                            }
                        }
                        .thenIf(ReportDashPageState.isDownloading) {
                            Modifier.opacity(0.7).cursor(Cursor.NotAllowed)
                        },
                    contentAlignment = Alignment.Center
                ) {
                    if (ReportDashPageState.isDownloading) {
                        DotLoading()
                    } else {
                        SpanText(
                            userDashWordLibrary.download_report.localized,
                            contentButtonTextStyle.toModifier().fontSize(1.cssRem).fontWeight(FontWeight.Bold)
                        )
                    }
                }
            } else {
                // Request Report
                val isRequested = history.reportRequested
                val isRequesting = ReportDashPageState.isRequestingReport
                
                Box(
                    modifier = if (isRequested || isRequesting) {
                        disabledContentButtonStyle.toModifier()
                    } else {
                        contentButtonStyle.toModifier()
                    }
                        .fillMaxWidth()
                        .minHeight(3.cssRem)
                        .onClick {
                            if (!isRequested && !isRequesting) {
                                ReportDashPageState.requestTestReport(history.testId, toast, scope)
                            }
                        },
                    contentAlignment = Alignment.Center
                ) {
                    if (isRequesting) {
                        DotLoading()
                    } else {
                        SpanText(
                            if (isRequested) userDashWordLibrary.request_pending.localized
                            else userDashWordLibrary.request_report.localized,
                            contentButtonTextStyle.toModifier().fontSize(1.cssRem).fontWeight(FontWeight.Bold)
                        )
                    }
                }
            }
        }
        
        Box(
            neutralContentButtonStyle.toModifier()
                .fillMaxWidth()
                .minHeight(2.5.cssRem)
                .onClick { modal.hide() },
            contentAlignment = Alignment.Center
        ) {
            SpanText(
                userDashWordLibrary.close.localized,
                Modifier.fontSize(1.cssRem).fontWeight(FontWeight.SemiBold).color(userPagePrimaryTextColor)
            )
        }
    }
}

@Composable
private fun StudentDataRow(value: String, label: String) {
    Column(Modifier.gap(0.2.cssRem)) {
        SpanText(
            value,
            Modifier
                .fontSize(1.35.cssRem)
                .fontWeight(FontWeight.Bold)
                .color(userPagePrimaryTextColor)
        )
        SpanText(
            label,
            Modifier
                .fontSize(1.cssRem)
                .fontWeight(FontWeight.Normal)
                .color(userPageSecondaryTextColor)
        )
    }
}